

import { ArrowCircleRightSharp, LocalDining } from '@mui/icons-material';
import Edit from '@mui/icons-material/Edit';
import EditOff from '@mui/icons-material/EditOff';
import Subject from '@mui/icons-material/Subject';
import Checkbox from '@mui/material/Checkbox';
import { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { CurrentPContext, MasterContext, MobiOrNotContext, OrderContext, UserContext } from '../ContextApi/context';

import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useHistory } from "react-router-dom";
import GoogleMapItem from '../DTechComp/GoogleMapItem';
import PopUpClearComp from "../DTechComp/PopUpClearComp";
import UserDetails from "../UsersLogs/UserDetails";
import utilsOrders from '../_Utils/utilsOrders';
import utilsRests from '../_Utils/utilsRests';
import OrderFunctions from './OrderFunctions';
import TheMount from './TheMount';
import TheWeightSelect from './TheWeightSelect';
import Scroll from 'react-scroll';
import MyDateTime from '../DTechComp/MyDateTime';
import MySpinner_Wait from '../DTechComp/MySpinner_Wait';
import PopUpIframe from '../DTechComp/PopUpIframe';
import Closed_Buis from '../DTechComp/Pop_Fixed/Closed_Buis';
import Delivery_Confirmd from '../DTechComp/Pop_Fixed/Delivery_Confirmd';
import Minimum_Order from '../DTechComp/Pop_Fixed/Minimum_Order';
import Kopon_Rejected from '../DTechComp/Pop_Fixed/Kopon_Rejected';
import TAKE_Confirmd from '../DTechComp/Pop_Fixed/TAKE_Confirmd';
import UserAdresses from '../UsersLogs/UserAdresses';
import utilsUsers from "../_Utils/utilsUsers";
import utilsGamma from '../_Utils/utilsGamma';

import { Helmet } from 'react-helmet';
import PopUpCardComIframe from '../DTechComp/PopUpCardComIframe';
import LoginPage from '../UsersLogs/LoginPage';
import utilsCardCom from '../_Utils/utilsCardCom';
import utilsKopons from '../_Utils/utilsKopons';
import ConnUrls from '../Connections/ConnectURL';
import ReactHtmlParser from 'react-html-parser';
import PopUpCCTokensCharge from '../DTechComp/PopUpCCTokensCharge';
import Crdit_Token_Problem from '../DTechComp/Pop_Fixed/Crdit_Token_Problem';
import GetTheAddress from './GetTheAddress';
import ChangeScheduledForPopup from './ChangeScheduledForPopup';
import SwitchNowOrFuturePopup from './SwitchNowOrFuturePopup';
import PopUpTheComp from '../DTechComp/PopUpTheComp';
import myFunctions, { isNativeApp } from '../myFunctions';
import BigPopUpMsg from '../DTechComp/BigPopUpMsg';
import PopUpMsg from '../DTechComp/PopUpMsg';
import PopUpsSlides from '../DTechComp/PopUpsSlides';
import PopUpHappy from "../DTechComp/PopUpHappy";
import PopUpCreditsUse from "../DTechComp/PopUpCreditsUse";
import utilsCredits from '../_Utils/utilsCredits';
var scroller = Scroll.scroller;

const TheOrderList = (props) => {



    const [master, setMaster] = useContext(MasterContext);
    const [order, setOrder] = useContext(OrderContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);
    const [mobiOrNot] = useContext(MobiOrNotContext);
    const [user, setUser, UserEffectFunction] = useContext(UserContext);
    const [thePopUp, setThePopUp] = useState("");
    const [loading, setLoading] = useState(true);

    const [yellowLineTxt, setYellowLineTxt] = useState("המשך לתשלום");
    const [payType, setPayType] = useState((order.payt != null) ? order.payt : "1");
    const [showContBtn, setShowContBtn] = useState(true);
    const [kopon, setKopon] = useState("")
    const [koponMsg, setKoponMsg] = useState("")
    const [approvedKoponMsg, setApprovedKoponMsg] = useState("")
    const [userCredits, setUserCredits] = useState(0);
    const [selectedCredits, setSelectedCredits] = useState(order.creditsUsed || 0);
    const [useCredits, setUseCredits] = useState((order.creditsUsed || 0) > 0);

    const [doDeliver, setDoDeliver] = useState();
    const [doTakeAway, setDoTakeAway] = useState();
    const [hideIframeCloseBtn, setHideIframeCloseBtn] = useState(false);
    // ה-iframe מרונדר בנפרד מ-thePopUp (לא כ-JSX קבוע בתוכו) כדי ש-hideCloseBtn
    // יוכל להתעדכן באמצע (כש-ThankPage בתוך ה-iframe מאשר הזמנה) בלי לבנות
    // מחדש את כל אלמנט הפופאפ
    const [cardComIframeUrl, setCardComIframeUrl] = useState(null);

    // מונה ניסיונות חיוב-בטוקן פעיל — משמש להתעלם מתשובה "יתומה" של ניסיון שהמשתמש כבר עזב
    const chargeAttemptId = useRef(0);

    // pushed: האם יש כרגע history entry ייעודי לפופאפ תשלום האשראי — Back בזמן
    // שהוא פתוח מדמה X (סוגר ומשחרר). orderApproved: נשמר לצורך תיעוד/הרחבה
    // עתידית; הניווט החוצה אחרי אישור מנוהל ב-ThankPage ולא כאן.
    const cardComHistoryState = useRef({ pushed: false, orderApproved: false });

    // תפיסת מכסת קופון פעילה (koponsBL.reserveKopon) — נתפסת בלחיצה על "המשך
    // לתשלום" ומשוחררת אם הלקוח יוצא מתהליך התשלום בלי להשלים. שני השדות
    // תמיד מתעדכנים יחד, כדי לדעת גם איזה טוקן לשחרר וגם על איזה קופון.
    const koponReservation = useRef({ koponId: null, token: null });

    // טיימר שמנקה את הקופון מההזמנה כשהתפיסה פגה (התפיסה נטושה בצד השרת אחרי
    // KOPON_RESERVATION_TTL_MINUTES). מונע מצב שהקופון "יושב" בסל אחרי שהתפיסה
    // כבר לא תקפה - אז הלקוח פשוט יזין אותו שוב ויקבל בדיקה טרייה.
    const koponExpiryTimer = useRef(null);
    // טיימר שסוגר חלון תשלום (קרדיטים/כרטיס שמור/iframe) שנשאר פתוח יותר מדי
    // זמן, כך שתהליך התשלום תמיד קצר מ-TTL של תפיסת הקופון. הלקוח מקסימום
    // ילחץ שוב על "שלם".
    const paymentPopupTimer = useRef(null);
    const PAYMENT_POPUP_MAX_MINUTES = 20;

    const history = useHistory();

    let popTiming = 0;


    const noUser = !user || user.usrmsg === "noUser";
    const noOrder = !order || Object.keys(order).length === 0 || order.restId === "";

    if (noUser || noOrder) {
        history.goBack();      // שולח אחורה
    }

    useEffect(() => {
        setCurrPage();
        return () => {
            if (koponExpiryTimer.current) clearTimeout(koponExpiryTimer.current);
            if (paymentPopupTimer.current) clearTimeout(paymentPopupTimer.current);
        };
    }, []);

    // מנקה את הקופון מההזמנה + מ-sessionStorage ומעדכן totalPrice בהתאם.
    // נקרא מהטיימר כשהתפיסה פגה, או ידנית כשצריך.
    const clearKoponFromOrder = () => {
        if (!order.orderKopon || order.orderKopon === "") return;
        order.orderKopon = null;
        order.koponReservationToken = "";
        order.totalPrice = OrderFunctions.getOrderTotalPrice(order);
        koponReservation.current = { koponId: null, token: null };
        setOrder({ ...order });
        setKoponMsg("");
        setApprovedKoponMsg("");
        try {
            sessionStorage.setItem("am_order", JSON.stringify(order));
        } catch { }
    };

    // מפעיל טיימר שמנקה את הקופון כשתפיסתו פגה. ttlMinutes מגיע מתשובת
    // reserveKopon (KOPON_RESERVATION_TTL_MINUTES בשרת) - מרווח ביטחון של
    // דקה כדי לנקות מעט לפני שהשרת מחשיב את התפיסה כנטושה.
    const armKoponExpiryTimer = (ttlMinutes) => {
        if (koponExpiryTimer.current) clearTimeout(koponExpiryTimer.current);
        const mins = Math.max(1, (parseInt(ttlMinutes) || 30) - 1);
        koponExpiryTimer.current = setTimeout(() => {
            clearKoponFromOrder();
        }, mins * 60 * 1000);
    };

    // מפעיל טיימר שסוגר חלון תשלום פתוח מדי זמן (חוזר לחלון פרטי ההזמנה).
    const armPaymentPopupTimer = () => {
        if (paymentPopupTimer.current) clearTimeout(paymentPopupTimer.current);
        paymentPopupTimer.current = setTimeout(() => {
            closeCardComPopup();
        }, PAYMENT_POPUP_MAX_MINUTES * 60 * 1000);
    };

    const clearPaymentPopupTimer = () => {
        if (paymentPopupTimer.current) {
            clearTimeout(paymentPopupTimer.current);
            paymentPopupTimer.current = null;
        }
    };

    // סוגר את פופאפ תשלום האשראי (קרדיטים/כרטיס שמור/iframe/כישלון) ומשחרר
    // את הכפתור הראשי לניסיון נוסף — ההזמנה שכבר נוצרה בשרת (אם נוצרה) לא
    // מבוטלת כאן; abandonPreviousPendingOrders בצד השרת מנקה אותה בהמשך
    // אם היא נשארת נטושה.
    // fromPopstate=true כשזה נקרא כתגובה ל-Back (ה-entry המלאכותי כבר נצרך
    // ע"י הדפדפן) — אחרת מבצע history.back() כדי לצרוך/לנקות אותו, כך ש-Back
    // הבא באמת יוצא מהתהליך במקום "לבזבז" לחיצה על entry ריק.
    const closeCardComPopup = (fromPopstate = false) => {
        clearPaymentPopupTimer();
        setThePopUp();
        setCardComIframeUrl(null);
        setShowContBtn(true);
        releaseKoponReservationIfAny();
        if (cardComHistoryState.current.pushed) {
            cardComHistoryState.current.pushed = false;
            if (!fromPopstate) history.goBack();
        }
    };

    // משחרר תפיסת קופון פעילה (אם יש) כשהלקוח יוצא מתהליך התשלום בלי לשלם —
    // כדי שמישהו אחר יוכל לתפוס את המכסה. לא מחכה לתשובת השרת: הלקוח כבר
    // עוזב את המסך, וגם אם הקריאה נכשלת יש TTL שמשחרר את התפיסה בכל מקרה.
    const releaseKoponReservationIfAny = () => {
        const { koponId, token } = koponReservation.current;
        if (koponId && token) {
            koponReservation.current = { koponId: null, token: null };
            utilsKopons.releaseKoponReservation(koponId, token).catch(() => { });
        }
    };

    // גשר ל-iframe של קארדקום (ErrorPayPage/ThankPage) שרץ בדומיין נפרד ומדבר
    // עם ההורה דרך window.parent — אין דרך אחרת ל-iframe cross-origin לקרוא
    // ישירות לפונקציות React של ההורה.
    useEffect(() => {
        window.parentOrderBridge = {
            closeIframePopup: () => closeCardComPopup(),
            notifyOrderSuccess: () => {
                cardComHistoryState.current.orderApproved = true;
                setOrder(OrderFunctions.clearOrd());
                setHideIframeCloseBtn(true);
            }
        };
        return () => { delete window.parentOrderBridge; };
    }, []);

    // Back בזמן שפופאפ תשלום האשראי פתוח: תמיד סוגר את הפופאפ ומשחרר את הכפתור
    // (נשאר באותו עמוד עם הסל). אחרי אישור התשלום — לא מנווטים כאן ל-/MyOrders:
    // ניווטי ה-iframe (redirect כפול של השרת + הניווטים הפנימיים של CARDCOM)
    // חולקים את ה-session history של הטאב, וה-entry המלאכותי שלנו נצרך בהם
    // בלי Back אמיתי של המשתמש — מה שגרם ל-onPopState לזרוק את הלקוח ל-/MyOrders
    // לפני שהספיק לראות את פופאפ "ההזמנה בוצעה". הניווט החוצה מנוהל כעת אך ורק
    // ע"י ThankPage (לחיצה על "המשך" או טיימר תצוגה מינימלי).
    useEffect(() => {
        const onPopState = () => {
            if (!cardComHistoryState.current.pushed) return;
            cardComHistoryState.current.pushed = false;
            closeCardComPopup(true);
        };
        window.addEventListener('popstate', onPopState);
        return () => window.removeEventListener('popstate', onPopState);
    }, []);

    // מוסיף history entry ייעודי אחד לכל תהליך תשלום האשראי (קרדיטים → כרטיס
    // שמור → iframe, כל שלב שיבוא), כדי ש-Back בכל שלב יחזור ישר לחלון פרטי
    // ההזמנה במקום להעיף את הלקוח הלאה אחורה לעמוד שקדם לכל ההזמנה. נקרא רק
    // פעם אחת בתחילת התהליך — מעברים בין שלבים לא דוחפים entry נוסף.
    const openPaymentFlow = () => {
        // גם אם ה-history entry כבר קיים (מעבר בין שלבים) - מרעננים את טיימר
        // הסגירה האוטומטית, כדי שכל שלב מקבל את מלוא הזמן.
        armPaymentPopupTimer();
        if (cardComHistoryState.current.pushed) return;
        cardComHistoryState.current = { pushed: true, orderApproved: false };
        history.push(history.location.pathname + history.location.search, { cardComPopup: true });
    };

    const openCardComPopup = (url) => {
        openPaymentFlow();
        setCardComIframeUrl(url);
    };

    useEffect(() => {

        props.shoTopStrp(false)
        window.scrollTo(0, 0);
        setLoading(true)
        setCurrPage();
        order["payt"] = (order.payt != null) ? order.payt : "1";

        //מנקה פריטים שמוגדרים ככמות 0
        order.Orders = order.Orders.filter(item => item.mount > 0);

        settingTheYellowline();


        setLoading(false)

    }, [])

    useEffect(() => {

    }, [])

    // מושך את הקרדיטים הזמינים (לא היתרה הגולמית). ההזמנה הנוכחית מוחרגת
    // כדי שניסיון תשלום חוזר עליה לא יראה 0 זמינים.
    const loadAvailableCredits = async () => {
        if (!master.masterSplitPay?.allowCredits || !user?._id) return 0;
        try {
            const data = await utilsCredits.getMyCredits(order.orderNUM);
            const avail = data.credits || 0;
            setUserCredits(avail);
            return avail;
        } catch {
            return 0;
        }
    };

    useEffect(() => {
        loadAvailableCredits();
    }, [master.masterSplitPay, user?._id]);

    // התקרה לשימוש בקרדיטים היא סכום ההזמנה המלא.
    // getOrderTotalPrice כבר לא מנכה קרדיטים, אז הוא הבסיס הנכון.
    const getBaseOrderTotal = () => {
        return OrderFunctions.getOrderTotalPrice(order);
    };

    const handleCreditsChange = (val) => {
        console.log(handleCreditsChange);
        const baseTotal = getBaseOrderTotal();
        const maxCredits = Math.min(userCredits, Math.max(0, baseTotal));
        const credits = Math.min(Math.max(0, parseInt(val) || 0), maxCredits);
        setSelectedCredits(credits);
        const updatedOrder = { ...order, creditsUsed: credits };
        setOrder(updatedOrder);
    };

    const toggleUseCredits = (checked) => {
        setUseCredits(checked);
        if (!checked) {
            handleCreditsChange(0);
        } else {
            const baseTotal = getBaseOrderTotal();
            handleCreditsChange(Math.min(userCredits, baseTotal));
        }
    };

    const goToBack = () => {
        history.goBack();

    }
    useEffect(() => {
        validatePayType();
    }, [master.masterPaymentsType, currentPage.paymentOptions, order.isFutureOrder]);

    // מחזיר את רשימת אמצעי התשלום המותרים ("1"=אשראי, "2"=מזומן) לפי אותה
    // לוגיקת עדיפויות של validatePayType: הזמנה עתידית < הגדרת מאסטר < הגדרת עסק.
    // משמש גם את validatePayType וגם את מסלול כשל ה-CARDCOM (newFramCardCom),
    // כדי שלא ניפול למזומן בעסק שמוגדר אשראי-בלבד.
    const getAllowedPayments = () => {
        if (order.isFutureOrder) return ["1"];

        if (master.masterPaymentsType !== "noSetting") {
            if (master.masterPaymentsType === "onlyCredit") return ["1"];
            if (master.masterPaymentsType === "onlyCash") return ["2"];
            if (master.masterPaymentsType === "creditAndCash") return ["1", "2"];
        }

        if (!currentPage.paymentOptions || currentPage.paymentOptions === "creditAndCash") {
            return ["1", "2"];
        }
        if (currentPage.paymentOptions === "onlyCredit") return ["1"];
        if (currentPage.paymentOptions === "onlyCash") return ["2"];

        return ["1", "2"];
    };

    const isCashAllowed = () => getAllowedPayments().includes("2");

    // ---- מונה כשלי CARDCOM 520 (מאוחד iframe+טוקן) ----
    // נשמר ב-sessionStorage ולא ב-state כי הוא צריך לשרוד רימאונט של הרכיב
    // בתוך אותה הזמנה, אבל להימחק כשמתחילים הזמנה חדשה. clearOrd() מאפס את
    // am_order, ולכן גם מנקה את המפתח הזה (ר' OrderFunctions.clearOrd).
    // נספר *רק* על errCode 520 - תקלה זמנית מול CARDCOM דרך Cloudflare -
    // ולא על כשל ERROR כללי אחר.
    const CC520_KEY = 'am_cardcom520Fails';
    const get520Fails = () => {
        const n = parseInt(sessionStorage.getItem(CC520_KEY), 10);
        return isNaN(n) ? 0 : n;
    };
    const bump520Fails = () => {
        const next = get520Fails() + 1;
        sessionStorage.setItem(CC520_KEY, String(next));
        return next;
    };
    const reset520Fails = () => sessionStorage.removeItem(CC520_KEY);

    const validatePayType = () => {
        //הזמנה עתידית ניתנת לתשלום באשראי בלבד - override על פני כל הגדרה
        //אחרת (מאסטר/עסק), נאכף גם בצד שרת ב-checkOrderAllowed
        let allowedPayments = getAllowedPayments();

        // אם payType לא קיים ברשימה, נאתחל לערך ברירת מחדל (אשראי)
        if (!allowedPayments.includes(payType)) {
            setPayType(allowedPayments[0]);
            let updatedOrder = { ...order, payt: allowedPayments[0] };
            setOrder(updatedOrder);
        }
    };

    var jumcodeChek = 1;
    const setCurrPage = async () => {

        let restPage = currentPage;
        //אם אין עמוד נוכחי, מביא את עמוד המסעדה
        if (currentPage.length <= 0) {
            restPage = await utilsRests.getRestById(order.restId);
            setCurrentPage({ ...restPage, pageTYp: "withConPay" });
        }

        const chans = MyDateTime.resolveBusinessChannels(restPage, master);

        //יורה רק כשאין אף ערוץ פעיל, ולא לפי שעות הפתיחה.
        //בסמנטיקה החדשה עסק יכול להיות מתויג "סגור" ובכל זאת לקבל
        //איסופים - ירי לפי שעות הפתיחה היה חוסם בדיוק את המקרה הזה.
        //הזמנה עתידית תקינה (isFutureOrder+scheduledFor שעדיין עומד בכל
        //הכללים) חייבת להמשיך גם כש-canOrderNow=false ל"עכשיו" - זה בדיוק
        //המצב הרגיל שלה: העסק סגור עכשיו, אבל ההזמנה מיועדת לזמן עתידי תקין.
        const isValidFutureOrder = order.isFutureOrder && order.scheduledFor &&
            MyDateTime.isFutureSlotValid(restPage, master, new Date(order.scheduledFor), order.OrderType).ok;

        if (!chans.canOrderNow && !isValidFutureOrder) {

            popTiming++;
            jumcodeChek++;

            setThePopUp(
                <PopUpClearComp
                    popFullComp={"specialPopComp onTopOfAll"}
                    cssStyl={"noPadding"}
                    btnFStyle={"fatInBtn"}
                    // closePop={() => setThePopUp()}
                    insideCss={"noPadding"}
                    theInsideComp={
                        <PopUpHappy key={jumcodeChek}
                            Title={["עסק זה סגור כרגע"]}
                            cssStyl={"okPOP onTopOfAll"}
                            topSlides={<PopUpsSlides key={"logInPop"}
                                TopImages={[{ img: master.nowCloseImg, txt: "" }]} />}
                            ContentText={[{ txt: "עסק זה כרגע סגור", css: "" }
                                , { txt: "ולא ניתן לבצע הזמנות", css: "" }]}
                            inLabel={""}
                            okClick1={() => history.goBack()}
                            okClick2={() => history.push(`/restaurants/${restPage.pageUrlFix != null &&
                                restPage.pageUrlFix != "" ? restPage.pageUrlFix : restPage._id}`)}
                            okTxt1={"סגור"}
                            okTxt2={"חזור לעמוד המסעדה"}
                        />

                    } />

            )

        }


        setDoDeliver(chans.deliveryOk);
        setDoTakeAway(chans.takeAwayOk);
    }

    useEffect(() => {

        settingTheYellowline();
        checkKoponPrice();
    }, [order])

    //כאשר מחובר, מגדיר את הטקסט על הכפתור הצבהוב בהתאם לאופי ההזמנה
    const settingTheYellowline = () => {
        //איסוף
        if (order.OrderType == "Take") {
            //מזומן או אשראי?
            //יש היפוך בגלל העברית אנגלית
            //1 == אשראי
            setYellowLineTxt((order.payt == "1") ? "המשך לתשלום" : "בצע הזמנה");
        }
        //משלוח
        else {

            setYellowLineTxt("המשך הזמנה");
        }

    }



    //הסתר או הצג כמות של מנה מסויימת
    const showHideMount = (elemId) => {

        let mountItm = document.getElementById(elemId);

        if (mountItm.classList.contains("slideMeUp")) {
            mountItm.classList.remove("slideMeUp");
        }
        else {
            mountItm.classList.add("slideMeUp");
        }
    }

    //הצג או הסתר הערות על המנה
    const showHideRemarks = (elemId) => {
        let Remarks = document.getElementById(`${elemId}_remarks`);
        let RemarksItm = document.getElementById(`${elemId}_remarksTxt`);
        let RemarksItmTxt = document.getElementById(`${elemId}_remarkstxLine`);

        if (Remarks.classList.contains("slideMeUp")) {
            Remarks.classList.remove("slideMeUp");
            RemarksItmTxt.classList.add("slideMeUp");
        }
        else {
            Remarks.classList.add("slideMeUp");
            RemarksItmTxt.classList.remove("slideMeUp");
        }
    }

    const removeFromOrder = (ordItmId) => {
        let filt = order.Orders.filter(itm => itm.orderItemId != ordItmId)
        order.Orders = filt;
        setOrder({ ...order })
    }

    //הצג או הסתר הערות על ההזמנה
    const showHideOrderRemarks = () => {

        let Remarks = document.getElementById(`orderRemarksDIv`);
        let RemarksItmTxt = document.getElementById(`orderRemarksTxt`);

        if (Remarks.classList.contains("slideMeUp")) {
            Remarks.classList.remove("slideMeUp");
            RemarksItmTxt.classList.add("slideMeUp");
        }
        else {
            Remarks.classList.add("slideMeUp");
            RemarksItmTxt.classList.remove("slideMeUp");
        }
    }

    //הגדר את הטקסט על הערות להזמנה
    const setTheOrderRemarks = () => {

        let RemarksItmTxt = document.getElementById(`orderRemarksTxt`);

        let RemarksItmTxtLine = document.getElementById(`orderRemarksTxtLine`);
        RemarksItmTxtLine.textContent = RemarksItmTxt.value;

        order.orderRemarks = "<p>" + RemarksItmTxt.value + "</p>";


        setOrder({ ...order });

        showHideOrderRemarks();
    }
    //הגדר את הטקסט על הערות המנה
    const setTheTxtRem = (index) => {

        let RemarksItm = document.getElementById(`${index}_remarksTxt`);
        let RemarksItmTxt = document.getElementById(`${index}_remarkstxLine`);
        RemarksItmTxt.textContent = RemarksItm.value;
        order.Orders[index].Remarks = RemarksItm.value;
        setOrder({ ...order });

        showHideRemarks(`${index}`);
    }

    //המפה המוצגת
    let googleMap =
        <>
            <div className={"RestGoogleMap"}>
                <GoogleMapItem mapLink={order.GoogleLink} />
            </div>
        </>


    const changeToPick = () => {
        order.OrderType = "Take"
        order.OrderTimes = myFunctions.checkForDeliverysDelay(master, currentPage.Take?.Time, "Take") || 20;

        order.OrderDelPrice = "0";
        // order.Address = currentPage.buissAddress;

        setOrder({ ...order });
    }

    //אותה לוגיקה בדיוק כמו channelOpenNow/channelFutureCapable ב-OrderTypeSelect.js.
    //ברירת המחדל בסכמה היא true - מסמכים ישנים עשויים להיות undefined ולא
    //false, ולכן !== false ולא בדיקת אמת ישירה
    const channelOpenNow = (channel) => channel === "Deliver" ? doDeliver : doTakeAway;
    const channelFutureCapable = (channel) => !!currentPage.futureOrdersEnabled &&
        (channel === "Deliver" ? currentPage.futureOrdersDelivery !== false : currentPage.futureOrdersTakeAway !== false);

    //"החלף מועד" מוצג גם על הזמנה עתידית קיימת (כמו היום), וגם על הזמנה
    //רגילה לעכשיו אם העסק תומך בהזמנה עתידית לערוץ הזה - כדי לאפשר מעבר
    //בשני הכיוונים
    const showChangeScheduledForBtn = (order.isFutureOrder && order.scheduledFor) ||
        (!order.isFutureOrder && channelFutureCapable(order.OrderType));

    const futureOrderEndTime = order.scheduledFor &&
        MyDateTime.getShortTime(new Date(new Date(order.scheduledFor).getTime() + (parseInt(order.OrderTimes) || 0) * 60 * 1000));

    //הפס הסגול "הזמנה עתידית ל-..." - מוצג רק כשזו באמת הזמנה עתידית.
    //אחרת null, כדי שתוכן ה"עכשיו" (זמן הגעה/איסוף מוערך) יטופל בתוך
    //takeAwayBlock/deliveryBlock עצמם לפי הערוץ - לא כאן, וגם לא באופן
    //גורף עם ניסוח של איסוף בלבד
    const futureOrderTimeBlock = () => {
        if (!(order.isFutureOrder && order.scheduledFor)) return null;
        return (
            <div className={"futureOrderTimeMobi"}>
                הזמנה עתידית ל {MyDateTime.getShortTime(order.scheduledFor)} {MyDateTime.getDate(order.scheduledFor)}  
            </div>
        );
    }

    let orderOrTake = <>
        <div className={"grayFrame"}>

            <div className={"futureBtnsRowWrap"}>
                <div className={"mobiBtnsMyOrder overflowHid"}>
                    <div className={"backToRestMenu centerText pointing"}
                        onClick={() => backToRestMenu()} >
                        <span className={`${!mobiOrNot ? "big_important" : ""}`}>חזור לתפריט</span>
                    </div>
                </div>
                {

                    doDeliver && doTakeAway &&
                    <div className={"mobiBtnsMyOrder overflowHid"}>
                        <div className={"backToRplacePick centerText pointing"}
                            onClick={() => { (order.OrderType !== "Take") ? changeToPick() : changeAddress(false) }}>

                            <span className={`${!mobiOrNot ? "big_important " : ""}`}>
                                {(order.OrderType === "Take") ? "החלף למשלוח" : "החלף לאיסוף"}</span>
                        </div>
                    </div>
                }
                {
                    (order.OrderType !== "Take") &&
                    <div className={"mobiBtnsMyOrder overflowHid"}>
                        <div className={"backToRplacePick2 centerText pointing"}
                            onClick={() => changeAddress(true)} >
                            <span className={`${!mobiOrNot ? "big_important" : ""}`}>החלף כתובת</span>
                        </div>
                    </div>
                }
                {
                    showChangeScheduledForBtn &&
                    <div className={"mobiBtnsMyOrder overflowHid"}>
                        <div className={`${(order.OrderType !== "Take") ? "backToRplacePick3" : "backToRplacePick2"} centerText pointing`}
                            onClick={() => changeScheduledFor()}>
                            <span className={`${!mobiOrNot ? "big_important" : ""}`}>החלף מועד</span>
                        </div>
                    </div>
                }
            </div>

            {
                (order.OrderType == "Take") ?
                    OrderFunctions.takeAwayBlock(
                        `ניתן יהיה לאסוף בתוך ${parseInt(order.OrderTimes) + 5} - ${order.OrderTimes} דק'`,
                        order.Address, futureOrderTimeBlock(), mobiOrNot, order.isFutureOrder && order.scheduledFor)
                    :
                    OrderFunctions.deliveryBlock(
                        `זמן הגעה מוערך ${parseInt(order.OrderTimes) + 10} - ${order.OrderTimes} דק'`,
                        currentPage, order.deliveryAddress, futureOrderTimeBlock(), mobiOrNot, order.isFutureOrder && order.scheduledFor)
            }
        </div>
    </>

    //פותח פופאפ בחירת תאריך/שעה חדשים להזמנה עתידית ("החלף מועד").
    //ChangeScheduledForPopup עוטף את FutureOrderPicker הקיים עם state
    //עצמאי משלו (ראה ההערה שם), כדי שהבחירה תתעדכן ריאקטיבית בתוך הפופאפ
    const openScheduledForPicker = () => {
        setThePopUp(
            <ChangeScheduledForPopup
                rest={currentPage}
                master={master}
                channel={order.OrderType}
                initialSlot={order.scheduledFor ? new Date(order.scheduledFor) : null}
                onClose={() => setThePopUp()}
                onConfirm={(slot) => {
                    order.isFutureOrder = true;
                    order.scheduledFor = slot.toISOString();
                    setOrder({ ...order });
                    setThePopUp();
                }}
            />
        )
    }

    //מבטל הזמנה עתידית וממיר להזמנה רגילה לעכשיו, לפי הערוץ הנוכחי -
    //אותו חישוב OrderTimes כמו changeToPick/continueToOrder
    const switchToNowOrder = () => {
        order.isFutureOrder = false;
        order.scheduledFor = null;
        if (order.OrderType === "Take") {
            order.OrderTimes = myFunctions.checkForDeliverysDelay(master, currentPage.Take?.Time, "Take") || 20;
        } else {
            order.OrderTimes = myFunctions.checkForDeliverysDelay(master, currentPage.Delivery?.Time, "Deliver") || 40;
        }
        setOrder({ ...order });
        setThePopUp();
    }

    //"החלף מועד" - אם גם "עכשיו" וגם "עתידי" תקפים לערוץ הנוכחי, שואלים
    //קודם מפורשות דרך SwitchNowOrFuturePopup. אחרת (העסק סגור עכשיו) קופצים
    //ישר לבורר תאריך/שעה, כמו היום
    const changeScheduledFor = () => {
        if (channelOpenNow(order.OrderType) && channelFutureCapable(order.OrderType)) {
            setThePopUp(
                <SwitchNowOrFuturePopup
                    onClose={() => setThePopUp()}
                    onNow={() => switchToNowOrder()}
                    onFuture={() => openScheduledForPicker()}
                />
            )
        } else {
            openScheduledForPicker();
        }
    }

    let popCOunts = 0;
    const changeAddress = (allowBack) => {
        popCOunts++;
        setThePopUp(
            <GetTheAddress key={popCOunts}
                theInsideComp={"bgLGray"}
                backFunc={true}
                allowBack={allowBack}
                GoTOPay={() => { continueToOrder(); setThePopUp(); }}
                closeMeFuc={() => { setThePopUp(); }}
                goBackToMenu={() => { setThePopUp() }}
                shoTopStrp={(tf) => { }}
                scrollToTop={(stUp) => { }} />

        )

    }


    const continueToOrder = () => {
        order.OrderType = "Deliver"
        order.OrderTimes = myFunctions.checkForDeliverysDelay(master, currentPage.Delivery?.Time, "Deliver") || 40;

        order.OrderDelPrice = order.deliveryAddress?.deliveryPrice;
        // order.Address = currentPage.buissAddress;

        setOrder({ ...order });

    }
    const connect = () => {

        setThePopUp(
            <PopUpClearComp
                popFullComp={"specialPopComp onTopOfAll"}
                cssStyl={"noPadding "}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                insideCss={"noPadding "}
                theInsideComp={
                    <LoginPage
                        theInsideComp={""}
                        backFunc={true}
                        closeMeFuc={() => setThePopUp()}
                        shoTopStrp={(tf) => { }}
                        scrollToTop={(stUp) => { }} />
                } />)


        // sessionStorage.setItem('bkPage', window.location.pathname);
        // history.push("/LoginPage")
    }

    const register = () => {
        setThePopUp(
            <PopUpClearComp BtnTxt={"סגור"}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                theInsideComp={
                    <UserDetails theInsideComp={""}
                        backFunc={true}
                        closeMeFuc={() => setThePopUp()}
                        shoTopStrp={(tf) => { }}
                        scrollToTop={(stUp) => { }}
                        connectWithNumber={() => { setThePopUp(); connect() }}
                    />
                } />)


    }

    //מושך מספר הזמנה להזמנה החדשה
    const register_theOrder = async () => {

        order.totalPrice = OrderFunctions.getOrderTotalPrice(order);
        order.orderNUM = order.orderNUM || await utilsOrders.getCounter();

    }


    // תופס את מכסת הקופון (אם יש קופון על ההזמנה) ממש בלחיצה על "המשך
    // לתשלום" - לפני שממשיכים לכל מסלול תשלום (מזומן/קרדיטים/כרטיס/iframe).
    // זו הנקודה היחידה שבה כל המסלולים עוברים, ולכן גם היחידה שמגינה מפני
    // מירוץ בין לקוחות שונים על אותה מכסה, בלי תלות באמצעי התשלום שכל אחד בחר.
    // מחזיר true אם אפשר להמשיך (אין קופון, או שהתפיסה הצליחה).
    const reserveKoponBeforePay = () => {
        return new Promise((resolve) => {
            if (!order.orderKopon || order.orderKopon === "") {
                resolve(true);
                return;
            }

            utilsKopons.reserveKopon(order.orderKopon._id).then((res) => {
                if (res.ok) {
                    koponReservation.current = { koponId: order.orderKopon._id, token: res.reservationToken };
                    order.koponReservationToken = res.reservationToken;
                    armKoponExpiryTimer(res.ttlMinutes);
                    resolve(true);
                }
                else {
                    setShowContBtn(true);
                    popTiming++;
                    setThePopUp(
                        <Kopon_Rejected key={popTiming}
                            okClick={() => {
                                order.orderKopon = null;
                                order.koponReservationToken = "";
                                order.totalPrice = OrderFunctions.getOrderTotalPrice(order);
                                setOrder({ ...order });
                                setKoponMsg("");
                                setThePopUp();
                                resolve(true);
                            }}
                            closePop={() => { setThePopUp(); resolve(false); }}
                        />
                    );
                }
            }).catch(() => {
                // תקלת רשת/שרת בבדיקת התפיסה - לא חוסמים הזמנה אמיתית על
                // תקלה חולפת, ממשיכים בלי קופון כדי לא לתקוע את הלקוח.
                order.orderKopon = null;
                order.koponReservationToken = "";
                order.totalPrice = OrderFunctions.getOrderTotalPrice(order);
                setOrder({ ...order });
                resolve(true);
            });
        });
    };

    //יוצר את ההזמנה במערכת וממשיך להמשך לתשלום, איסוף או משלוח?
    const getAddressOrPay = async () => {

        setShowContBtn(false);

        try {
            const canContinue = await reserveKoponBeforePay();
            if (!canContinue) {
                setShowContBtn(true);
                return;
            }

            let tempo = await register_theOrder();

            if (order.OrderType == "Take") {
                await setToTake();
            }
            else {
                await setToDeliver();
            }
        }
        catch (error) {
            console.error("Error in getAddressOrPay:", error);
            setShowContBtn(true);
        }

    }


    //המשך הזמנה כמשלוח
    const setToDeliver = async () => {

        //בודק אם מוגדר מינימום מחיר למשלוח
        //במידה וכן עובד לפי המחיר המוגדר
        //במידה ולא, עובד לפי המינימום המוגדר במאסטר
        let mindelP = (currentPage.Delivery.MiniDelPrice != null &&
            currentPage.Delivery.MiniDelPrice != "") ?
            currentPage.Delivery.MiniDelPrice : master.MiniDelPrice;

        //רק במידה ומחיר המינימום למשלוח הושג.
        if (parseInt(OrderFunctions.getOrderPrice(order)) >= parseInt(mindelP)) {
            askAboutCredits((creditsAmount) => getMoney(creditsAmount));
        }
        else {

            setShowContBtn(true);
            popTiming++;
            setThePopUp(
                <Minimum_Order
                    okClick={() => {
                        setThePopUp(); backToRestMenu();
                    }}
                    mindelP={mindelP}
                    btnClick2={() => { setThePopUp(); }}
                />
            )
        }

    }


    const backToRestMenu = () => {

        history.push(`/restaurants/${currentPage.pageUrlFix != null && currentPage.pageUrlFix != "" ?
            currentPage.pageUrlFix : currentPage._id}`)
    }





    const getMoney = async (creditsAmount) => {


        setThePopUp(<div className={"onTopOfScreen"}><MySpinner_Wait /></div>);

        // אם הקרדיטים מכסים את מלוא סכום ההזמנה אין מה לחייב בכרטיס —
        // דילוג מלא על תהליך הסליקה (אחרת חסר הבדל בין הצגת הפופאפ לחיוב בפועל).
        if (order.payt != "2" && OrderFunctions.getOrderToPay({ ...order, creditsUsed: creditsAmount }) <= 0) {

            let orderMyFood = await creatTheorder(creditsAmount);
            if (!orderMyFood) return;
            popApprovedOrder(orderMyFood);

        }
        else if (order.payt != "2") {

            let orderMyFood = await creatTheorder(creditsAmount);
            if (!orderMyFood) return;

            await creditCardCharge(orderMyFood);

        }
        else {

            let orderMyFood = await creatTheorder(creditsAmount);
            if (!orderMyFood) return;
            popApprovedOrder(orderMyFood)
        }
    }

    // כשל CARDCOM ביצירת דף התשלום. הפופאפ הוא אינפורמטיבי בלבד — כפתור "אישור"
    // יחיד שסוגר וחוזר לחלון פרטי ההזמנה. אנחנו לא נוגעים ב-payt / בקרדיטים:
    // אם הלקוח רוצה מזומן (ורק אם העסק מאפשר) הוא ישנה בעצמו את אופן התשלום במסך,
    // אחרת ילחץ שוב "המשך לתשלום" ויעבור את סבב האשראי מחדש. ה-orderNUM כבר ב-state
    // (creatTheorder עדכן אותו), כך שהניסיון הבא מעדכן את אותה הזמנה ולא יוצר כפילות.
    // ההבדל היחיד בין עסק שמאפשר מזומן לעסק אשראי-בלבד הוא נוסח ההודעה.
    let crditProblem = () => {
        setShowContBtn(true);
        const lastLine = isCashAllowed()
            ? "ניתן לנסות שוב או לשנות את אופן התשלום למזומן."
            : "ניתן לנסות שוב בעוד מספר רגעים.";
        return (
            <PopUpMsg
                Title={["בעיית חיוב"]}
                nosnippet={true}
                ContentText={[
                    { txt: "התגלתה בעייה זמנית במערכת החיוב", css: "" },
                    { txt: "ולכן לא ניתן היה לבצע את התשלום.", css: "" },
                    { txt: lastLine }
                ]}
                inLabel={""}
                BtnTxt={"אישור"}
                okClick={() => { setThePopUp(); }}
                cssStyl={"orderOneClose"}
                errorMsg={""}
            />
        )
    }


    // מוצג מהניסיון הרביעי ואילך שבו CARDCOM מחזיר 520 על אותה הזמנה. אינפורמטיבי
    // בלבד - "אישור" סוגר וחוזר לחלון פרטי ההזמנה. המונה לא מתאפס כאן, כך שכל 520
    // נוסף יציג שוב את אותה הודעה עד שיקרה משהו אחר (חיוב מוצלח / הזמנה חדשה).
    let cardComRepeatedFailure = () => {
        setShowContBtn(true);
        return (
            <PopUpMsg
                Title={["בעיית חיוב"]}
                nosnippet={true}
                ContentText={[
                    { txt: "ניסית 4 פעמים לחייב באותו כרטיס ללא הצלחה,", css: "" },
                    { txt: "כנראה שישנה בעיה עם חיוב הכרטיס." }
                ]}
                inLabel={""}
                BtnTxt={"אישור"}
                okClick={() => { setThePopUp(); }}
                cssStyl={"orderOneClose"}
                errorMsg={""}
            />
        )
    }


    let crditTokenProblem = () => {
        setShowContBtn(true);
        return (<Crdit_Token_Problem
            okClick={() => {
                paytypChanched(1);
                order.payt = "1";
                // getMoney();

                setThePopUp();
                // popApprovedOrder();
            }}
            closePop={() => closeCardComPopup()} />
        )
    }

    const creditCardCharge = async (orderMyFood) => {

        let checkForUserTokensCC = await utilsUsers.checkForUserTokensCC(user._id);
        if (checkForUserTokensCC) {
            setThePopUp(

                <PopUpCCTokensCharge
                    CCtokens={checkForUserTokensCC}
                    removeToken={(tkToremove) => removeToken(tkToremove, orderMyFood)}
                    okClick={(ValueBk) => payByToken(ValueBk, orderMyFood)}
                    btnClick2={() => { chargeAttemptId.current++; newFramCardCom(orderMyFood); setThePopUp() }}
                    handleClose={() => { chargeAttemptId.current++; closeCardComPopup() }}
                    cssStyl={"ccTknPopCard centerPop"}
                />)
        }
        else {
            newFramCardCom(orderMyFood);
        }

    }


    const newFramCardCom = async (orderMyFood) => {
        let restPage = currentPage;
        const useJ5 = restPage?.cardComJ5 === true;

        // Use J5 or regular payment based on restaurant setting
        const endpoint = useJ5 ? 'createJ5Hold' : 'goCardCom';
        // retryCount - כמה 520 רצופים כבר נספרו על ההזמנה הזו. השרת רושם את זה
        // בלוג ההתראה מהניסיון הרביעי ואילך.
        let cardComBk = await utilsCardCom[endpoint]({
            order: orderMyFood.ordr,
            retryCount: get520Fails()
        });

        if (cardComBk.data != 'ERROR') {
            reset520Fails();
            setHideIframeCloseBtn(false);
            openCardComPopup(cardComBk.Url)
        }
        else if (cardComBk.errCode === 520) {
            // תקלה זמנית מול CARDCOM (Cloudflare). סופרים ניסיון, ומהרביעי ואילך
            // מציגים את הודעת "ניסית 4 פעמים" במקום ההודעה הרגילה. המונה לא מתאפס.
            const fails = bump520Fails();
            setThePopUp(fails >= 4 ? cardComRepeatedFailure() : crditProblem());
        }
        else {
            // כשל ERROR אחר (לא 520). פופאפ אינפורמטיבי בלבד (crditProblem) - לא
            // נוגע ב-payt ולא במונה. ההזמנה נשארת כ"ממתין לחיוב".
            setThePopUp(crditProblem())
        }
    }


    const payByToken = async (theTokeparams, orderMyFood) => {
        const myAttempt = ++chargeAttemptId.current;
        let restPage = currentPage;
        // Check if restaurant has J5 enabled and token has ApprovalNumber
        const useJ5 = restPage?.cardComJ5 === true && theTokeparams?.TokenApprovalNumber;
        console.log("Using J5:", useJ5);
        let chargeTokback;
        try {
            if (useJ5) {
                // Charge J5 held transaction
                chargeTokback = await utilsCardCom.chargeJ5({
                    order: orderMyFood.ordr,
                    theTokeparams: theTokeparams
                });
            } else {
                // Regular token charge
                chargeTokback = await utilsCardCom.cardChargeToken({
                    order: orderMyFood.ordr,
                    theTokeparams: theTokeparams,
                    retryCount: get520Fails()
                });
            }

            // המשתמש כבר עזב את הפופאפ הזה (X / תשלום בכרטיס אחר) — להתעלם מתשובה יתומה
            if (chargeAttemptId.current !== myAttempt) return;

            // כשל 520 בחיוב הטוקן (תקלה זמנית מול CARDCOM). זהה למסלול ה-iframe:
            // סופרים ניסיון, ומהרביעי ואילך "ניסית 4 פעמים". המונה לא מתאפס.
            if (chargeTokback && chargeTokback.data === 'ERROR' && chargeTokback.errCode === 520) {
                const fails = bump520Fails();
                setThePopUp(fails >= 4 ? cardComRepeatedFailure() : crditTokenProblem());
                return;
            }

            // Check if response is valid
            if (chargeTokback &&
                chargeTokback !== "Token chargeError" &&
                chargeTokback !== "NO PERMISS" &&
                chargeTokback.data !== 'ERROR' &&
                !chargeTokback.error) {
                reset520Fails();
                popApprovedOrder(chargeTokback)
            }
            else {
                console.error("Token charge failed:", chargeTokback);
                setThePopUp(crditTokenProblem())
            }
        } catch (error) {
            if (chargeAttemptId.current !== myAttempt) return;
            console.error("Error in payByToken:", error);
            setThePopUp(crditTokenProblem())
        }

    }

    const removeToken = async (tkToremove, orderMyFood) => {

        let bk = await utilsUsers.removeCCTok(user._id, tkToremove);
        await creditCardCharge(orderMyFood)
    }


    //יוצר הזמנה חדשה
    const creatTheorder = async (creditsAmount) => {

        order.totalPrice = OrderFunctions.getOrderTotalPrice(order);

        //מנקה פריטים שמוגדרים ככמות 0
        order.Orders = order.Orders.filter(item => item.mount > 0);

        order.orderSource = isNativeApp() ? 'app' : 'web';

        // נקבע במפורש מהפרמטר ולא מ-order.creditsUsed: הוא מגיע מה-state
        // (setOrder אסינכרוני) שעדיין לא התעדכן ברגע הזה - ראה askAboutCredits.
        if (creditsAmount != null) {
            order.creditsUsed = creditsAmount;
        }

        let theNorder = await utilsOrders.orderMyFood({ order, user });

        // ההזמנה נדחתה ע"י השרת (מחוץ לשעות / אמצעי תשלום לא מותר / לקוח חסום-
        // טוקן מול עסק J5). מציגים פופאפ עם נוסח השרת ומחזירים null - כל קורא
        // בודק את הערך ומפסיק את זרימת התשלום.
        if (theNorder && theNorder.orderBlocked) {
            setShowContBtn(true);
            popTiming++;
            setThePopUp(
                <PopUpMsg
                    key={popTiming}
                    Title={["לא ניתן להשלים את ההזמנה"]}
                    nosnippet={true}
                    ContentText={[{ txt: theNorder.errMsg || "לא ניתן להשלים את ההזמנה מעסק זה כרגע.", css: "" }]}
                    inLabel={""}
                    BtnTxt={"אישור"}
                    okClick={() => { setThePopUp(); }}
                    cssStyl={"orderOneClose"}
                    errorMsg={""}
                />
            );
            return null;
        }

        let temp = { ...order, orderId: theNorder.orderId, orderNUM: theNorder.orderNumber }
        setOrder(temp)

        return theNorder;

    }


    //מאשר הזמנה חדשה
    const popApprovedOrder = async (theOrder) => {

        // ניקוי מזהה ההזמנה ברגע שהפופאפ קופץ — ההזמנה כבר נוצרה בשרת, אין
        // עוד צורך ב-orderNUM/orderId ב-am_order. אם לא ננקה כאן, לקוח שסוגר
        // את האפליקציה על הפופאפ בלי ללחוץ "המשך" משאיר orderNUM תקוע, וההזמנה
        // הבאה מאותו עסק נשלחת עם אותו מספר -> השרת מעדכן (דורס) במקום ליצור.
        // הגנת שרת לכך בוטלה (commit 6adc3ea1) כי היא שברה את ה-idempotency של
        // CARDCOM (ExternalUniqTranId=orderNUM) וגרמה לחיוב כפול, אז התיקון
        // חייב להיות כאן בצד הלקוח.
        //
        // מנקים דרך ה-state (לא כתיבה ישירה ל-sessionStorage) כי useEffect על
        // [order] ב-context.js דורס כל כתיבה ידנית. משאירים restId/Orders כמו
        // שהם — רק setOrder({...prev, orderNUM:"", orderId:undefined}) — כדי
        // ש-noOrder לא יהפוך ל-true ולא יורה history.goBack (ר' שורה 105).
        // הפופאפ (TAKE/Delivery_Confirmd) לוכד עותק עמוק של theOrder ב-useState
        // initializer מה-props, כך שהניקוי לא משנה לו את התצוגה.
        setOrder(prev => ({ ...prev, orderNUM: "", orderId: undefined }));

        let tempOrdType = theOrder.ordr ? theOrder.ordr.OrderType : theOrder.OrderType;
        if (tempOrdType == "Take") {
            popTiming++;
            setThePopUp(
                <TAKE_Confirmd order={theOrder} key={popTiming}
                    okClick={() => { OrderFunctions.clearOrd(); setThePopUp(); history.push("/MyOrders") }}
                />
            )

        }
        else {
            popTiming++;
            setThePopUp(
                <Delivery_Confirmd order={theOrder} key={popTiming}
                    okClick={() => { OrderFunctions.clearOrd(); setThePopUp(); history.push("/MyOrders") }}
                />
            )
        }
    }


    const askAboutCredits = async (callback) => {

        // קרדיטים לא נתמכים בתשלום במזומן: הכסף עובר פיזית דרך העסק, ואי אפשר
        // גם להסתיר ממנו שיש קרדיטים וגם לצפות שיגבה מהלקוח את הסכום הנכון.
        // לכן החלון פשוט לא מוצע — הלקוח שבחר מזומן משלם את מלוא הסכום.
        if (order.payt == "2") {
            if ((Number(order.creditsUsed) || 0) > 0) handleCreditsChange(0);
            callback(0);
            return;
        }

        // מתחיל כאן את "תהליך תשלום האשראי" (קרדיטים/כרטיס שמור/iframe) -
        // Back מכל שלב בתהליך יחזור ישר לחלון פרטי ההזמנה
        openPaymentFlow();

        // רענון לפני ההצעה: ייתכן שהלקוח הקצה את הקרדיטים להזמנה אחרת
        // ממכשיר אחר מאז טעינת הדף.
        const availableCredits = await loadAvailableCredits();

        const baseTotal = getBaseOrderTotal();
        const allowFull = master.masterSplitPay?.allowFullCredits;
        const effectiveMax = allowFull
            ? Math.min(availableCredits, baseTotal)
            : Math.min(availableCredits, Math.max(0, baseTotal - 1));

        if (!master.masterSplitPay?.allowCredits || effectiveMax <= 0) {
            if ((Number(order.creditsUsed) || 0) > 0) handleCreditsChange(0);
            callback(0);
            return;
        }

        setThePopUp(
            <PopUpCreditsUse
                userCredits={availableCredits}
                maxCredits={effectiveMax}
                orderTotal={baseTotal}
                initialSelected={selectedCredits > 0 ? Math.min(selectedCredits, effectiveMax) : effectiveMax}
                onUse={(amount) => {
                    handleCreditsChange(amount);
                    setThePopUp();
                    // מעבירים את הסכום ישירות ל-callback ולא מסתמכים על ה-state
                    // שעודכן ב-handleCreditsChange - setOrder אסינכרוני, וקריאה
                    // מיידית ל-getMoney/creatTheorder הייתה עדיין רואה את ה-order
                    // הישן (creditsUsed=0) ומחייבת את מלוא הסכום בכרטיס.
                    callback(amount);
                }}
                onSkip={() => {
                    handleCreditsChange(0);
                    setThePopUp();
                    callback(0);
                }}
                handleClose={() => closeCardComPopup()}
            />
        );
    };

    //המשך הזמנה כאיסוף
    const setToTake = async () => {
        askAboutCredits(async (creditsAmount) => {
            if (order.payt == "2") {

                setThePopUp(<div className={"onTopOfScreen"}><MySpinner_Wait /></div>);
                let orderMyFood = await creatTheorder(creditsAmount);
                if (!orderMyFood) return;
                popApprovedOrder(orderMyFood);
            }
            else {

                getMoney(creditsAmount);
            }
        });
    }



    ///הערות הזמנה
    let ordRemarks = <>
        <div className={"ordItmLine remarksLine pointing"} onClick={() => showHideOrderRemarks()}>
            <span className={"rSideFirst"}><Subject aria-hidden="true" /></span>
            <span className={"bold rSideMiddle big"}>הערות נוספות להזמנה</span>
            <span className={"bold lSideSmall"}></span>
        </div>
        <div className={"ordItmLine remarksTxtLine"}>
            <span className={"rSideFirst"}></span>
            <span className={"rSideMiddle bold big"} id={`orderRemarksTxtLine`}></span>
            <span className={"lSideSmall"}></span>
        </div>
        <div id={`orderRemarksDIv`} className={"ordItmLine itemRemraks spacePadBig slideMeUp"}>
            <textarea id={`orderRemarksTxt`} maxLength='250' className={"remarksTxt MbigFont"}
                placeholder={"תרצה לציין עוד משהו? אולי קוד כניסה? או שיש כלב בחצר?"}>
            </textarea>
            <div className={"ButtonMe2"} onClick={() => setTheOrderRemarks()}>שמור</div>
        </div>
    </>

    ///המוצרים בהזמנה
    let ordersItems = order.Orders?.map((item, index) => {
        if (item.mount > 0) {
            return (

                <li key={index} className={"ordItem spaceButtomBig "}>

                    <div className={"ordItmLine"}>
                        {/* <Checkbox
                            onChange={() => showHideMount(index)}
                            icon={<Edit sx={{ color: 'black' }} />}
                            checkedIcon={<EditOff sx={{ color: 'black' }} />}
                            sx={{ '& .MuiSvgIcon-root': { fontSize: 20 } }}
                            className={"chkBxChange rSideFirst"}
                        /> */}
                        <div className='col-12 fullRow overflowHid'>
                            <div className='col-8 onRight overflowHid'>
                                <div className='col-12 overflowHid'>
                                    <div className='col-2 onRight tdmin10 overflowHid'>
                                        <span className={"ordItemMount mainMount"}>{item.mount} יח'&nbsp;</span>
                                    </div>
                                    <div className='col-6 onRight overflowHid'>
                                        <span className={"fullRow big"}> {item.productName} </span>
                                        <span className={"fullRow small"}> {item.prodInfo} </span>
                                        <span className={"fullRow small"}> {item.unitPrice} </span>
                                    </div>
                                    <div className='col-4 onRight overflowHid'>
                                        {/* <div className="col-4 onLeft overflowHid"> */}
                                        <div className={"imgOnCart"}>
                                            {item.prodImageUrl ? <img src={`${ConnUrls.media(item.prodImageUrl)}`}
                                                className={"smallDIspImage"} alt={item.productName} />
                                                : ""}
                                        </div>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>


                            <div className='col-4 onRight overflowHid'>
                                <span style={{ textAlign: "left", paddingBottom: "10px" }}
                                    className={"bold col-12 onLeft big"}>
                                    ₪ {item.weightValue !== undefined
                                        ? ((parseFloat(item.prodPrice) * parseFloat(item.weightValue)) / 1000).toFixed(2)
                                        : (parseFloat(item.prodPrice) * parseInt(item.mount)).toFixed(2)
                                    }
                                </span>
                                {/* edit mount */}
                                <div id={index} className={"col-12 onLeft itemMount"}>
                                    {/* <span className={"bold itemMountRI"}>כמות:</span> */}
                                    <span className={"bold itemMountLf"}>
                                        {item.weightValue !== undefined ? (
                                            <TheWeightSelect
                                                itemId={item.orderItemId}
                                                weightValue={item.baseWeightValue || item.weightValue}  // ← **שנה כאן**
                                                remFromOrder={() => { }}
                                            />
                                        ) : (
                                            <TheMount
                                                itemId={item.orderItemId}
                                                remFromOrder={() => removeFromOrder(item.orderItemId)}
                                            />
                                        )}
                                    </span>
                                </div>
                                <button type="button" className={"btnReset removeItemFromCartBtn"} onClick={() => removeFromOrder(item.orderItemId)}>
                                    <span>הסר מהסל</span>
                                </button>
                            </div>
                        </div>
                    </div>



                    {OrderFunctions.theItemSpecials(item)}

                    <button type="button" className={"btnReset ordItmLine remarksLine pointing"} onClick={() => showHideRemarks(index)}>
                        <span className={"rSideFirst"}><Subject aria-hidden="true" /></span>
                        <span className={"bold rSideMiddle"}>הערות</span>
                        <span className={"bold lSideSmall"}></span>
                    </button>
                    <div className={"ordItmLine remarksTxtLine"}>
                        <span className={"rSideFirst"}></span>
                        <span className={"rSideMiddle"}
                            id={`${index}_remarkstxLine`}></span>
                        <span className={"lSideSmall"}></span>
                    </div>
                    <div id={`${index}_remarks`} className={"ordItmLine itemRemraks spacePadBig slideMeUp"}>
                        <textarea id={`${index}_remarksTxt`} maxLength='250' className={"remarksTxt MbigFont"}
                            placeholder={"ספר לנו איך אתה אוהב את האוכל, יש בעיה עם אלרגנים?"}>
                        </textarea>
                        <div className={"ButtonMe2"} onClick={() => setTheTxtRem(index)}>שמור</div>
                    </div>


                </li>


            )
        }
    })


    //רטבים מוצמדים מוזמנים
    let stickedSauces =
        order.StickedSauces?.length > 0 ?
            <div className={"spaceButtomBig ordLstSpesBlk "}>
                <div className={"smallIconWrap"}>
                    <img src={"/PermanentImages/suse-icon.png"} className={"smallIcon"} alt="" />
                </div>
                <span className={"bold fullRow "}>רטבים מוצמדים</span>
                <span className={"veryVerySmall"}>
                    &nbsp;{(order.freeSaucess > 0) ? `(${order.freeSaucess} ללא עלות)` : ""}
                </span>
                <span className={"bold lSideSmall"}>
                    {OrderFunctions.getStickedSauces(order) > 0 ? OrderFunctions.getStickedSauces(order) + "  ₪" : ""}
                </span>

                {
                    order.StickedSauces?.map((sauce, indx) => {
                        return (
                            <div key={indx} className={"sucItem"}>

                                <span className={"rSideMiddle"}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className={"tdmin10"}>
                                                    <span className={"ordItemMount"}>{sauce.mount} יח'&nbsp;</span>
                                                </td>
                                                <td>
                                                    <span className={"ordItemMount"}> {sauce.servType}</span>
                                                </td>
                                                <td>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </span>
                            </div>
                        )
                    })
                }
            </div>
            : ""



    //מספר סועדים
    let Dinners =
        // (currentPage.chkForkNife || currentPage.chkChopStiks) ?
        (order.Dinners && order.Dinners > 0) ?
            <div className={"sucItem spacePadSmall"} >
                <span className={"rSideMiddle"}>
                    <span className={"bold"}>מספר סועדים: </span>
                    <span>{order.Dinners}</span>
                </span>
            </div>
            : "";

    // : "";

    //סכו"ם
    let ANife =
        (currentPage.chkForkNife) ?
            <div className={"sucItem spacePadSmall"}>
                <span className={"rSideMiddle"}><span className={"bold"}>סכו"ם חד פעמי: </span><span>{order.getfANife ? "כן" : "אין צורך "}</span></span>
            </div>
            : "";

    //צופסטיקס
    let chupstiks =
        (currentPage.chkChopStiks) ?
            <div className={"sucItem spacePadSmall"}>
                <span className={"rSideMiddle"}><span className={"bold"}>צ'ופסטיקס: </span>
                    <span>{order.getChupstiks ? "כן" : "אין צורך "}</span></span>
            </div>
            : "";


    //אופן תשלום
    const creditCard = (
        <div className={`${!mobiOrNot ? "onRight" : ""} col-md-6 mb-2 startNBlock`}>
            <FormControl component="fieldset">
                <div className={"veryBig bold spaceRightVeryLong"}>אופן תשלום</div>
                <RadioGroup row aria-label="אופן תשלום" value={payType} name="payt" onChange={(e) => paytypChanched(e.target.value)}>
                    {(() => {
                        let options = [];
                        //הזמנה עתידית - אשראי בלבד, ללא קשר להגדרות המאסטר/העסק
                        if (order.isFutureOrder) {
                            options.push(
                                <FormControlLabel key="credit" value="1" className="blackRadiolbl" control={<Radio className="blackRadio" />} label="אשראי" />
                            );
                            return options;
                        }
                        if (master.masterPaymentsType !== "noSetting") {
                            if (master.masterPaymentsType === "onlyCredit" || master.masterPaymentsType === "creditAndCash") {
                                options.push(
                                    <FormControlLabel key="credit" value="1" className="blackRadiolbl" control={<Radio className="blackRadio" />} label="אשראי" />
                                );
                            }
                            if (master.masterPaymentsType === "onlyCash" || master.masterPaymentsType === "creditAndCash") {
                                options.push(
                                    <FormControlLabel key="cash" value="2" className="blackRadiolbl" control={<Radio className="blackRadio" />} label="מזומן" />
                                );
                            }
                        } else {
                            if (!currentPage.paymentOptions || currentPage.paymentOptions === "creditAndCash") {
                                options.push(
                                    <FormControlLabel key="credit" value="1" className="blackRadiolbl" control={<Radio className="blackRadio" />} label="אשראי" />,
                                    <FormControlLabel key="cash" value="2" className="blackRadiolbl" control={<Radio className="blackRadio" />} label="מזומן" />
                                );
                            } else if (currentPage.paymentOptions === "onlyCredit") {
                                options.push(
                                    <FormControlLabel key="credit" value="1" className="blackRadiolbl" control={<Radio className="blackRadio" />} label="אשראי" />
                                );
                            } else if (currentPage.paymentOptions === "onlyCash") {
                                options.push(
                                    <FormControlLabel key="cash" value="2" className="blackRadiolbl" control={<Radio className="blackRadio" />} label="מזומן" />
                                );
                            }
                        }
                        return options;
                    })()}
                </RadioGroup>
            </FormControl>
        </div>
    );


    //הפעלת קופון
    const IhaveKopon =
        <div className={`${(!mobiOrNot) ? "onLeft" : ""} col-md-6 mb-2 startNBlock spaceButtom`}>
            <div className={"veryBig bold spaceButtom spaceRightVeryLong"}>יש לי קופון
                <span className={"spaceRightLongi vSmall specDotClose"}>
                    {order.orderKopon && order.orderKopon != "" ?
                        `הקופון הופעל, ${order.orderKopon.KoponDiscount}${order.orderKopon.KoponDiscType === '1' ? "₪" : "%"} הנחה`
                        : koponMsg}
                </span>
            </div>
            {(order.orderKopon && order.orderKopon != "") ? "" :
                <>
                    <input className={"roundedInputTxt spaceMargRightVeryLong "}
                        type="text" id={"kopoInput"} placeholder={"הזן קופון"} value={kopon}
                        onChange={(e) => { setKopon(e.target.value) }}
                        onKeyUp={(e) => checkIfEnterOnKop(e)} />
                    <button type="button" className={"btnReset goKoponBtn centerText pointing"}
                        onClick={() => koponCheck()} >
                        <span>הפעל</span>
                    </button>
                </>
            }
        </div>

    //בודק תקינות קופון
    const koponCheck = async () => {

        if (kopon == "") {
            setKoponMsg("לא הוזן קופון")
        } else if (kopon.length < 6) {
            setKoponMsg("קופון לא תקין")
        }
        else {

            let koponResault = await utilsKopons.chekckKopon(kopon, order);
            if (koponResault.errMsg !== null) {
                if (koponResault.errMsg === 'הקופון הופעל') {

                    let tempoOrd = koponResault.order;
                    setOrder(tempoOrd);


                }
                else { setKoponMsg(koponResault.errMsg) }

            }
        }
    }

    //בודק אם יש קופון פעיל בהזמנה, במידה ויש,
    // בודק מחיר המנימום שלו לא גבוה יותר ממחיר הסה"כ
    const checkKoponPrice = () => {

        if (order.orderKopon && order.orderKopon !== "") {

            let kop = order.orderKopon;
            let theTot = OrderFunctions.getOrderTotalPrice(order) + (parseInt(kop.prodPrice) * -1);
            if (theTot < kop.MinmumForOrder) {
                // let tempOrd = [...order];               
                setKoponMsg("הקופון דורש מינימום הזמנה של " + kop.MinmumForOrder + " ₪")
                setOrder({ ...order })
            }
        }
    }

    const checkIfEnterOnKop = (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
            koponCheck();
        }
    }

    //אופן התשלום השתנה ופה מעדכנים את ההזמנה
    const paytypChanched = (ptyp) => {
        setPayType(ptyp);
        let ordTemp = { ...order };
        ordTemp.payt = ptyp;
        setOrder({ ...ordTemp });

    }

    //סיכום מחירים
    let TotPrices =
        <>
            <div className={"veryBig bold spacePad startNBlock centerText"} style={!mobiOrNot ? { width: "80%" } : {}}>כל המחירים בשקלים וכוללים מע"מ</div>
            <div className={"ordItmLine totalTxt"}>
                <div className={"bold totalTxtR"}>סכום ההזמנה</div>
                <div className={"bold totalTxtL"}>{OrderFunctions.getOrderPrice(order).toFixed(2)} ₪ </div>
            </div>

            {(order.OrderType == "Deliver") ?
                <div className={"ordItmLine totalTxt"}>
                    <div className={"bold totalTxtR"}>משלוח</div>
                    <div className={"bold totalTxtL"}>{order.OrderDelPrice ? parseFloat(order.OrderDelPrice).toFixed(2) : "0.00"} ₪ </div>
                </div> : ""}

            {(order.orderKopon && order.orderKopon !== "") &&
                <div className={"ordItmLine totalTxt"}>
                    <div className={"bold totalTxtR"}>קופון {order.orderKopon.Name}</div>
                    <div className={"bold totalTxtL"}>{order.orderKopon.KoponDiscount}{order.orderKopon.KoponDiscType === '1' ? " ₪" : " %"}</div>
                </div>}

            {selectedCredits > 0 &&
                <>
                    <div className={"ordItmLine totalTxt"}>
                        <div className={"bold totalTxtR"}>סה"כ ההזמנה</div>
                        <div className={"bold totalTxtL"}>{OrderFunctions.getOrderTotalPrice(order).toFixed(2)} ₪ </div>
                    </div>

                    <div className={"ordItmLine totalTxt"}>
                        <div className={"bold totalTxtR"}>אשדוד בתפריט קרדיט</div>
                        <div className={"bold totalTxtL"}>-{selectedCredits} ₪</div>
                    </div>
                </>}

            <div className={"ordItmLine totalTxt"}>
                <div className={"bold big totalTxtR"}>סה"כ לתשלום</div>
                <div className={"bold big totalTxtL"}>{OrderFunctions.getOrderToPay(order).toFixed(2)} ₪ </div>
            </div>
        </>

    // הרשמה/התחברות/ המשך לתשלום
    let QuickReg =
        <>
            {(user?._id == null) ?
                <div className={"startNBlock"}>

                    <button type="button" className="btnReset ContinueToPayLine pointing" onClick={() => connect()}>
                        <div className={"getToKnowBtn bold big centerText"}>התחבר</div>
                    </button>

                    <div className={"getToKnowTxt"}>משתמש רשום? התחבר בSMS</div>
                    <br />

                    <button type="button" className={"btnReset ContinueToPayLine pointing"} onClick={() => register()}>
                        <div className={"getToKnowBtn bold big centerText"}>הרשם</div>
                    </button>
                    <br />

                    <div className={"getToKnowTxt"}>בוא נכיר אותך קצת - הנתונים ישמרו בקניה הבאה</div>

                </div>
                :
                <button type="button" disabled={!showContBtn} className={`btnReset ContinueToPayLine pointing ${(showContBtn) ? "" : "btnDisabled"} `} onClick={() => getAddressOrPay()}>
                    <div className={"getToKnowBtn bold big centerText"}>{yellowLineTxt}</div>
                </button>
            }

        </>


    let totalDinners =
        (Dinners != "" || ANife != "" || chupstiks != "") ?
            <div className={"ordItmLine spaceAndLine"}>
                <span className={"rSideFirst"}><LocalDining aria-hidden="true" /></span>
                <span className={"rSideMiddle"}>
                    {Dinners}
                    {ANife}
                    {chupstiks}
                </span>
                <span className={"bold lSideSmall"}></span>
            </div>
            : ""

    return (
        loading ? <MySpinner_Wait /> :
            <>

                {order.Orders.length <= 0 ? <div className={"noItmes huge centerText"}>אין פריטים להזמנה.</div> :

                    <div className={"TheOrderList"}>
                        {(mobiOrNot) ?
                            <div className={"headOnFixC SecondFont bold big"}>
                                {currentPage.buissName}
                                <button type="button" className={`btnReset backSdOnlyBtn`} aria-label="חזור" onClick={() => goToBack()}>
                                    <ArrowCircleRightSharp aria-hidden="true" />
                                </button>
                            </div>
                            : ""}

                        {googleMap}
                        <div className={"TheOrderListIn ordLstWrap"}>

                            {/* <div className={"veryBig bold spaceRightVeryLong"}>סוג ההזמנה</div> */}
                            <div className={"col-md-12 mb-2 fullRow overflowHid"}>
                                <div className={"overflowHid"}>
                                    {orderOrTake}
                                </div>
                                {/* {
                                <div className={"backToRestMenu centerText pointing spaceMargTopBig spaceMargBottomBig"}
                                    onClick={() => backToRestMenu()} >
                                    <span>חזור לתפריט</span>
                                </div>
                            } */}
                                {
                                    (!mobiOrNot) ?
                                        <div className={"bold anak centerText spaceMargTopBig"}>{currentPage.buissName}</div> : ""
                                }
                            </div>
                            <h1 className={"veryBig bold spaceRightVeryLong"}>ההזמנה שלך</h1>
                            <ul className="ordersItemsList">{ordersItems}</ul>
                            {stickedSauces}
                            {totalDinners}
                            {ordRemarks}

                            <div className={"col-md-12 mb-2 fullRow overflowHid"}>
                                {creditCard}
                                {IhaveKopon}
                            </div>
                            {TotPrices}
                            <br />
                            {QuickReg}
                        </div>

                        {/* <ContinueToPay theTxt={"המשך לתשלום"} nxUrl="" withPrice={true} /> */}
                        {/* <ContinueToPay theTxt={"המשך לתשלום"} withPrice={true} /> */}
                        {thePopUp}
                        {cardComIframeUrl &&
                            <PopUpCardComIframe
                                cssStyl={""}
                                ContentText={[]}
                                theData={cardComIframeUrl}
                                hideCloseBtn={hideIframeCloseBtn}
                                cancelClick={() => closeCardComPopup()}
                            />
                        }
                    </div>
                }


                <Helmet
                    meta={[
                        {
                            property: "og:url", content: `${ConnUrls.siteDomainNam}/MyOrder`
                        }
                    ]}>
                    <link rel="canonical" href={`${ConnUrls.siteDomainNam}/MyOrder`} />
                </Helmet>


            </>

    )


}
export default TheOrderList;

